<mat-toolbar [ngClass]="{invisible: !visible, visible: visible, contrast: hasContrast}"
			 (mouseover)="toggle()"
			 (mouseout)="toggle()"
>
	<p>Created with <mat-icon class="animated pulse infinite" color="primary">favorite</mat-icon>
		by SCHEU-DENTAL &copy; {{currentYear}} [Version {{config.versionLabel}}]</p>

</mat-toolbar>
